<template>
  <el-dialog :close-on-click-modal="false" :modal-append-to-body="modalAppendToBody" :append-to-body="appendToBody"
             :height="height" :width="width" @size-change="handleResizeChange" :body-padding="bodyPadding"
             class="x-list-page-dialog common-dialog fixed-height-dialog-title"
             @opened="handleOpened" @closed="handleClosed" ref="dialog" :title="title" v-bind="$attrs"
             v-on="$listeners">
    <x-list-page ref="listPage" class="x-list-page-dialog-content" v-bind="$attrs" v-on="$listeners"
                 :condition-config="realConditionConfig" :column-cache="realColumnCache" @keydown="handleKeyDown">
      <template v-for="(item) in slotArray" v-slot:[item.name]="scope">
        <slot :name="item.name" v-bind="scope"></slot>
      </template>
      <template v-slot:footer="scope">
        <slot name="footer" v-bind="scope"></slot>
      </template>
    </x-list-page>
  </el-dialog>
</template>

<script>
import listPageConfigMixin from '../x-list-page/list-page-config-mixin';
import {
  getButtonSlotArray,
  getColumnCacheName, initModel
} from '../../util/componentUtil';
import {
  clearConditionConfigModel,
  getConditionSlotArray
} from '@/util/componentCoreUtil';
import {FIELD_TYPE_INPUT} from '@/util/x-condition-constant';
import searchListDialogMixin from '../../mixin/search-list-dialog-mixin';
import commonDialogMixin from '../../mixin/common-dialog-mixin';

export default {
  name: 'XListPageDialog',
  inheritAttrs: false,
  mixins: [listPageConfigMixin, commonDialogMixin, searchListDialogMixin],
  props: {
    api: Function,
    conditionConfig: Object,
    handleResult: Function,
    queryParamsConverter: Function,
    presetQueryParams: Object,
    handleQueryParams: Function,
    columnCache: String,
    bodyPadding: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      realColumnCache: ''
    };
  },
  methods: {
    handleResizeChange() {
      this.$nextTick(() => {
        this.$refs.listPage.handleResize();
      });
    },
    handleOpened() {
      this.addListListener();
      initModel({model: this.conditionConfig.model, list: this.conditionConfig.list, reset: true});
      this.getListPage().getGridInstance().recalculate(true).then(() => {
        if (this.$listeners.opened) {
          return;
        }
        this.reLoadData();
      });
    },
    handleClosed() {
      this.removeListListener();
      if (this.conditionConfig && this.conditionConfig.model) {
        clearConditionConfigModel({conditionConfig: this.conditionConfig});
      }
      const listPage = this.$refs.listPage;
      if (!listPage) {
        return;
      }
      const xTable = listPage.getXTable();
      if (!xTable) {
        return;
      }
      xTable.clearSort();
      const instance = xTable.getGridInstance();
      instance.clearCheckboxRow();
      instance.closeTooltip();
      instance.loadData([]);
    },
    search() {
      this.reLoadData();
    },
    async quickQuery(args) {
      const $args = args || {};
      initModel({model: this.conditionConfig.model, list: this.conditionConfig.list, reset: true});
      Object.assign(this.conditionConfig.model, $args);
      const queryParams = Object.assign({}, this.conditionConfig.model, this.queryParams);
      if (this.handleQueryParams) {
        await this.handleQueryParams({queryParams});
      }
      const res = await this.api(queryParams);
      if (res.isFail()) {
        return Promise.reject(new RequestError(res.msg));
      }
      return Promise.resolve(res.data);
    },
    hide() {
      this.$refs.dialog.hide();
    },
    show() {
      this.$refs.dialog.show();
    },
    getAllRecords() {
      return this.getListPage().getTableData().fullData;
    },
    getRecords() {
      return this.getListPage().getXTable().getRecords();
    }
  },
  watch: {
    presetQueryParams: {
      handler(newVal) {
        if (!newVal) {
          return;
        }
        Object.assign(this.queryParams, newVal);
      },
      deep: true,
      immediate: true
    },
    columnCache: {
      handler() {
        // 因为this.$route会随着页面跳转而改变，realColumnCache不能做成计算属性
        this.realColumnCache = this.columnCache ? this.columnCache : getColumnCacheName({
          name: this.$route.path,
          suffix: 'x-list-page-dialog'
        });
      },
      immediate: true
    }
  },
  computed: {
    slotArray() {
      const arr = getButtonSlotArray(this.$attrs.buttonConfig);
      arr.push(...getConditionSlotArray(this.conditionConfig));
      return arr;
    },
    realConditionConfig() {
      const config = Object.assign({}, this.conditionConfig);
      if (!Array.isArray(config.list)) {
        return config;
      }
      const hasOwnProperty = Object.prototype.hasOwnProperty;
      for (const item of config.list) {
        // 给输入框加上enter事件
        if (item.type !== FIELD_TYPE_INPUT || hasOwnProperty.call(item, 'enter')) {
          continue;
        }
        item.enter = () => {
          this.reLoadData();
        };
      }
      return config;
    }
  },
  beforeDestroy() {
    this.handleClosed();
  }
};
</script>
